<router-outlet />
<simple-notifications 
  [options]="{ 
    timeOut: 3000, 
    showProgressBar: true, 
    clickToClose: true, 
    position: ['top', 'right'] 
  }">
</simple-notifications>



